export const renderFileHeader = (position: number) => {
  switch (position) {
    case 0:
      return 'Terms and Conditions'
    case 1:
      return 'Disclosure Statement'
    case 2:
      return 'Other'
    case 3:
      return 'Contract'
    case 4:
      return 'Gas Acknowledgement'
    case 5:
      return 'Notice of Cancellation'
    case 6:
      return 'Welcome Letter'
    default:
      return 'File'
  }
}
